const getApiUrl = () => {
    const isLocalhost = window.location.hostname === 'localhost' || 
                        window.location.hostname === '127.0.0.1' ||
                        process.env.NODE_ENV === 'development';
    
    if (isLocalhost) {
      // return 'http://localhost:3001';
      return process.env.REACT_APP_API_URL;
    }
      return process.env.REACT_APP_API_URL;
  };
  
  export const API_URL = getApiUrl();